/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dock': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" _fill="#8300BF" fill-rule="nonzero" cx="12" cy="12" r="12"/><g stroke-linecap="square"><path pid="1" d="M10.508 12.257l1.415 1.414-3.718 3.718h2.829v2h-6v-.121h-.122v-1.294l-.06-.06.06-.06v-4.587h2v2.587l3.596-3.597zm8.669-7.426v.12h.121v1.293l.06.061-.06.06v4.587h-2V8.366l-3.596 3.596-1.414-1.414 3.716-3.717h-2.827v-2h6z" _fill="#FFF" fill-rule="nonzero"/></g></g>'
  }
})
